var render = function render(){var _vm=this,_c=_vm._self._c;return _c('binds-portal',{attrs:{"binds-attach-to-parent":_vm.bindsAttachToParent}},[_c('transition',{attrs:{"name":"binds-overlay"}},[(_vm.bindsActive)?_c('div',_vm._g({staticClass:"binds-overlay",class:_vm.overlayClasses},_vm.$listeners)):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }